import { render } from "./AIInterface.vue?vue&type=template&id=2fae4c96&scoped=true"
import script from "./AIInterface.vue?vue&type=script&lang=ts"
export * from "./AIInterface.vue?vue&type=script&lang=ts"

import "./AIInterface.vue?vue&type=style&index=0&id=2fae4c96&lang=scss"
import "./AIInterface.vue?vue&type=style&index=1&id=2fae4c96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fae4c96"

export default script